import { ResponsiveImage, SectionTitle } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { baseline, mq } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const IMAGE = {
  ASPECT_RATIO: 250 / 206,
  WIDTH: `250px`,
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
})`
  width: calc(100vw - 50px); /* screen-width - padding (52px) */
  min-height: 342px;

  ${mq(`smallOnly`)} {
    width: 564px; /* Card width (616px) - padding (52px) */
    min-height: 354px;
  }

  ${mq(`mediumUp`)} {
    width: 642px; /* Card width (698px) - padding (54px) */
    min-height: 360px;
  }
`

const Inner = styled(VLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
  spacing: 1,
})`
  max-width: 550px;
`

const ImageWrapper = styled.div`
  width: ${IMAGE.WIDTH};
`

const Footer = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  align: LAYOUT_ALIGN.CENTER,
})`
  ${CopyParagraph} {
    text-align: left;
    max-width: 342px;
    ${baseline([1, 1, 0])}

    ${mq(`smallOnly`)} {
      max-width: 520px;
    }

    ${mq(`mediumUp`)} {
      max-width: 602px;
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Card = ({ title, illustration, bodyAst }) => (
  <Layout>
    <Inner>
      <ImageWrapper>
        <ResponsiveImage
          aspectRatio={IMAGE.ASPECT_RATIO}
          src={illustration.url}
          alt={illustration.alt}
        />
      </ImageWrapper>
      <Footer>
        <SectionTitle align={[`center`]}>{title}</SectionTitle>
        <CopyRenderer htmlAst={bodyAst} />
      </Footer>
    </Inner>
  </Layout>
)

Card.propTypes = {
  title: PropTypes.string.isRequired,
  illustration: PropTypes.object.isRequired,
  bodyAst: PropTypes.object.isRequired,
}

export default Card
